import React from "react";
import { LoadingProps } from "../types";
import { useCommandDropdown } from "../context";
import { Box, CircularProgress, Typography } from "@mui/material";

export function Loading({ children, className }: LoadingProps) {
    const { isLoading } = useCommandDropdown();
    
    // Only show when loading
    if (!isLoading) {
        return null;
    }
    
    return (
        <Box 
            className={className} 
            sx={{ 
                padding: 3, 
                textAlign: "center",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: 2,
            }}
        >
            {children || (
                <>
                    <CircularProgress size={24} />
                    <Typography variant="body2" sx={{ opacity: 0.7 }}>
                        Loading...
                    </Typography>
                </>
            )}
        </Box>
    );
}

export default Loading;
